import { type FilterValues } from "components/filters/FilterContext";
import { getSortOption } from "components/filters/Filters/FilterTypes/TaskSortFilterType";
import { mapKeywordFilterToInstruction, mapOwnersFilterToInstruction, mapResponseToKeywordFilter, mapResponseToOwnerFilter, mapResponseToTaskManagerPeriodFilter, mapTaskManagerPeriodFilterToInstruction } from "components/filters/mappingUtils";

export const mapFilterValuesToInstruction = (
  filterSet: server.dto.FilterSets,
  filter: FilterValues,
  page: number,
  perPage: number
): server.dto.ListUserTaskInstruction => {
  return {
    keyword: mapKeywordFilterToInstruction(filter.keyword),
    ownerUserIds: mapOwnersFilterToInstruction(filter.owners),
    taskManagerPeriod: mapTaskManagerPeriodFilterToInstruction(filter.taskManagerPeriod),
    order: filter.taskManagerSort.sortOption.value,
    page,
    perPage,
    cache: filterSet,
  };
};

export const mapResponseToFilterValues = (
  response: server.dto.ListUserTaskFilters,
  _: FilterValues
): Partial<FilterValues> => ({
  keyword: mapResponseToKeywordFilter(response.keyword),
  owners: mapResponseToOwnerFilter(response.ownerUsers),
  taskManagerPeriod: mapResponseToTaskManagerPeriodFilter(response.taskManagerPeriodFilter),
  taskManagerSort: {
    sortOption: getSortOption(response.sort)
  }
});
